import { atom } from 'jotai'

/**
 * タリフのインポートModalの表示状態
 */
export const isOpenTariffImportModalAtom = atom<boolean>(false)

isOpenTariffImportModalAtom.debugLabel = 'isOpenTariffImportModalAtom'
